import React, { useEffect, useRef, useState } from 'react'
import type { InputRef } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import Tube from '../../../../../types/api/tube'
import EditableInput from './components/editable-input'
import { EditableCellType } from '../../../constants/constants'
import EditableSelect from './components/editable-select'
import EditableDate from './components/editable-date'
import { EndpointQueryParameters } from '../../../../../types/strapi/strapi'
import EditableSelectUser from './components/editable-select-user'

interface EditableCellProps {
    title: React.ReactNode
    editable: boolean
    dataIndex: NamePath
    record: Tube
    editableCellType: EditableCellType
    tubesQueryParams: EndpointQueryParameters
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    editableCellType,
    tubesQueryParams,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false)
    const inputRef = useRef<InputRef>(null)

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus()
        }
    }, [editing])

    const toggleEdit = () => {
        setEditing(!editing)
    }

    const editableCell = () => {
        switch (editableCellType) {
            case 'input':
                return (
                    <EditableInput
                        inputRef={inputRef}
                        namePath={dataIndex}
                        record={record}
                        toggleEdit={toggleEdit}
                        queryParams={tubesQueryParams}
                    />
                )

            case 'select':
                return (
                    <EditableSelect
                        inputRef={inputRef}
                        namePath={dataIndex}
                        record={record}
                        toggleEdit={toggleEdit}
                        queryParams={tubesQueryParams}
                    />
                )
            case 'datePicker':
                return (
                    <EditableDate
                        inputRef={inputRef}
                        namePath={dataIndex}
                        record={record}
                        toggleEdit={toggleEdit}
                        queryParams={tubesQueryParams}
                    />
                )
            case 'selectUser':
                return (
                    <EditableSelectUser
                        inputRef={inputRef}
                        namePath={dataIndex}
                        record={record}
                        toggleEdit={toggleEdit}
                        queryParams={tubesQueryParams}
                    />
                )

            default:
                break
        }
    }

    let childNode = children

    if (editable) {
        childNode =
            editing && record.stamps && record.stamps[0] ? (
                editableCell()
            ) : (
                <div
                    className='editable-cell-value-wrap'
                    style={{
                        width: '100%',
                        height: '100%',
                        minHeight: 20,
                    }}
                    onClick={toggleEdit}
                >
                    {children}
                </div>
            )
    }

    return (
        <td
            {...restProps}
            style={{
                padding: '1px 6px ',
            }}
        >
            {childNode}
        </td>
    )
}

export default EditableCell
